export const NEW_SESSION_EVENT = 'new_session_event';
